import { LazyLoad } from '@petconsole/pure-fe-mui';

const MyOrder = LazyLoad(() => import('./MyOrderApp'));

export { MyOrder };
